<template>
  <div>
    <div class="box-tab">
      <div id="accordion">
        <div class="panel box-collapse border-color-skin">
          <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
            <h3 class="box-title">
              <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS73E2']['70'] }}
            </h3>
          </div>
          <div id="details1" class="panel-collapse collapse in tab-detail">
            <div class="panel-body">
              <div class="detail detail-responsive">

                <div class="detail-block">
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRMS73E2']['10'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ setYearOutput(searchIndex.year) }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRMS73E2']['20'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ searchIndex.codcours2 }} - {{ lovCurrentDesc('codcours', searchIndex.codcours2) }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRMS73E2']['30'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ searchIndex.numclseq }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRMS73E3']['20'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ indexSelected.codempid }} - {{ indexSelected.desc_codempid }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRMS73E3']['30'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ indexSelected.val_code }} - {{ indexSelected.val_name }}</div>
                      </div>
                    </div>
                  </form>
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-4 control-label">{{ labels['HRMS73E3']['40'] }}</label>
                      <div class="col-md-4">
                        <div class="form-control readonly-field-color">{{ setDateOutput(indexSelected.val_date) }}</div>
                      </div>
                    </div>
                  </form>
                </div>

                <div class="col-md-5">
                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-5 control-label">{{ labels['HRMS73E2']['70'] }}</label>
                        <!-- <template v-if="detail.tab1.detail.codform===''"> -->
                          <div class="col-md-7">
                            <hrms-lov v-model="paramSearchDetailForm.codform"
                                  @focusout.native="receivedDetailForm()"
                                  lovType="codform"
                                  :disabled="disableForm"
                                  :nowLang="nowLang"
                                  v-validate="'required'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codform"
                                  name="codform"
                                  maxlength="4" />
                          </div>
                    </div>
                  </form>

                  <form class="form-horizontal">
                    <div class="form-group margin-b-5">
                      <label class="col-md-5 control-label">{{ labels['HRMS73E2']['130'] }}</label>
                      <div class="col-md-7">
                        <textarea class="form-control" 
                                  v-model="detail.tab1.detail.descommt"
                                  maxlength="600" 
                                  v-validate="'max:600'"
                                  data-vv-name="descommt"
                                  :has-error="errors.has('descommt')" ></textarea>
                        <div class="text-error" v-show="errors.has('descommt')">{{errors.first('descommt')}}</div>
                        <div class="remark-limit-character">{{ dispLimitLabel(600) }}</div> 
                      </div>
                    </div>
                  </form>
                  <div class="box-footer">
                    <button type="button" class="btn bg-color-skin" @click="save()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>
                  </div>
                  <div class="box-footer">
                    <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-reply"></i>{{ labelsButton['back'] }}</button>
                  </div>
                </div>

                <div class="col-md-7" v-if="detail.tab1.table1.rows.length > 0">
                  <div class="col-md-12 clear-padding">
                    <div class="evaluation-wrapper">
                      <template v-for="dataGroup in detail.tab1.table1.rows">
                        <group  :labels="labels"
                                :dataGroup="dataGroup"
                                :choices="detail.tab1.table2.rows"
                                name="hrms73e-detail"/>
                      </template>
                    </div>
                  </div>
                  <div class="col-md-12 clear-padding">
                    <div class="evaluation-sum">
                      {{ labels['HRMS73E2']['120'] }} {{ calResultScore(detail.tab1.table1.rows) }}/{{ calTotalScore(detail.tab1.table1.rows) }}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>



  </div>
</template>

<script>
import group from 'components/hrms73e/group'
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms73e-detail',
  data () {
    return {
      toggleCodform: false,
      paramSearchDetailForm: {
        codform: this.detail.tab1.detail.codform
      }
    }
  },
  props: [ 'labels',
    'labelsButton',
    'detail',
    'nowLang',
    'toggle',
    'searchIndex',
    'indexSelected',
    'codeval',
    'disableForm',
    'lovCurrentDesc',
    'descCodeval',
    'postHrms73eSave',
    'receivedHrms73eDetail',
    'receivedHrms73eDetailForm'
  ],
  watch: {
    'detail.tab1.detail.codform' () {
      if (this.detail.tab1.detail.codform !== '') {
        this.paramSearchDetailForm.codform = this.detail.tab1.detail.codform
      } else {
        this.paramSearchDetailForm.codform = this.indexSelected.codform
      }
    }
    // 'paramSearchDetailForm.codform' () {
    //   if (this.detail.tab1.detail.codform === '' && this.paramSearchDetailForm.codform !== '') {
    //     let detailParams = {
    //       p_codform: this.paramSearchDetailForm.codform
    //     }
    //     this.receivedHrms73eDetailForm(detailParams)
    //   }
    // }
    // 'indexSelected.codform' () {
    //   this.paramSearchDetailForm.codform = this.indexSelected.codform
    // }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    },
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      return {
        searchIndex: this.searchIndex,
        indexSelected: this.indexSelected,
        detail: this.detail
      }
    },
    save () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.postHrms73eSave(_this.saveParams())
        }
      })
    },
    calResultScore (dataGroups) {
      if (dataGroups.length > 0) {
        return dataGroups.map((dataGroup) => {
          return parseFloat(dataGroup.qtyscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        })
      }
    },
    calTotalScore (dataGroups) {
      if (dataGroups.length > 0) {
        return dataGroups.map((dataGroup) => {
          return parseFloat(dataGroup.qtyfscor)
        }).reduce((a, b) => {
          return parseFloat(a) + parseFloat(b)
        })
      }
    },
    receivedDetailForm () {
      if (this.detail.tab1.detail.codform === '' && this.paramSearchDetailForm.codform !== '') {
        let detailParams = {
          p_codform: this.paramSearchDetailForm.codform
        }
        this.receivedHrms73eDetailForm(detailParams)
      }
    }
  },
  components: {
    group
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?7624aae1